import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { ProfessionalPositionApiRepository } from '../repositories/professional-position-api.repository';
import { ProfessionalPositionCacheRepository } from '../repositories/professional-position-cache.repository';
import { ProfessionalPositionInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class ProfessionalPositionProvider {
    constructor(
        private professionalPositionApiRepository: ProfessionalPositionApiRepository,
        private professionalPositionCacheRepository: ProfessionalPositionCacheRepository
    ) {}

    find(): Observable<Transaction<ProfessionalPositionInterface[]>> {
        return concat(
            this.professionalPositionCacheRepository.load(),
            this.professionalPositionApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.professionalPositionCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
